import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Lottie from 'react-lottie';
const SIZES = {
  xs: 8,
  md: 16,
  lg: 32,
  xl: 40
}; // This is needed to access lottie functionality that is not directly accessible through react-lottie

class LottieSub extends Lottie {
  componentDidMount() {
    super.componentDidMount();

    if (this.props.initialStateIsActive) {
      this.anim.goToAndStop(this.anim.totalFrames - 1, true);
    }
  }

}

export const LottieAnimation = ({
  icon,
  autoPlay,
  loop,
  isActive,
  size,
  overideHeight,
  overideWidth,
  ariaLabel
}) => {
  const defaultOptions = {
    loop,
    autoplay: autoPlay,
    animationData: icon
  };
  const [iconDirection, setIconDirection] = useState(-1);
  useEffect(() => {
    setIconDirection(isActive ? 1 : -1);
  }, [isActive]);
  const height = overideHeight || SIZES[size];
  const width = overideWidth || SIZES[size];
  return /*#__PURE__*/React.createElement(LottieSub, {
    ariaLabel: ariaLabel,
    options: defaultOptions,
    height: height,
    width: width,
    direction: iconDirection,
    initialStateIsActive: isActive
  });
};
LottieAnimation.propTypes = {
  icon: PropTypes.shape({}).isRequired,
  ariaLabel: PropTypes.string.isRequired,
  autoPlay: PropTypes.bool,
  loop: PropTypes.string,
  isActive: PropTypes.bool,
  size: PropTypes.oneOf(Object.keys(SIZES)),
  overideWidth: PropTypes.number,
  overideHeight: PropTypes.number
};
LottieAnimation.defaultProps = {
  autoPlay: false,
  loop: 'false',
  isActive: false,
  size: 'md',
  overideWidth: null,
  overideHeight: null
};